import { Typography } from '@material-ui/core'
import PaymentTermIcon from '@material-ui/icons/AccountTree'
import { useParams } from 'react-router-dom'

import { getTranslate } from '../../localization'
import useStyles from './styles/PaymentTermAddHeader.styles'

export const PaymentTermAddHeader = () => {
  const classes = useStyles()
  const { paymentTermID } = useParams<{ paymentTermID: string }>()

  return (
    <div className={classes.header}>
      <PaymentTermIcon fontSize="large" />
      <Typography className={classes.title} variant="h3" gutterBottom>
        {getTranslate(paymentTermID ? 'PaymentTerm' : 'Add New PaymentTerm')}
      </Typography>
    </div>
  )
}
